import React from "react";
import { Link } from "react-router-dom";

const base64Encode = (id) => {
    return btoa(id.toString()); // Encode ID ke Base64
};

const ListKasi = ({ listKasi }) => {
    const dataKasi = listKasi?.data || []
    return (
        <section id="team" className="py-10 bg-gray-100">
            <div className="container px-5 mx-auto">
                <div className="mb-10 text-center">
                    <h2 className="mb-3 text-5xl font-bold uppercase">Proker and Team</h2>
                    <p className="text-gray-500">This is our Team.</p>
                </div>
                <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                    {dataKasi.slice(0, 3).map((item) => (
                        <div
                            key={item.encrypted_id}
                            className="overflow-hidden bg-white rounded-lg shadow-lg"
                        >
                            <img
                                src={item.url_logo ? `https://admin.sman2amlapura.sch.id/images/Activity/${item.url_logo}` : "/images/default.png"}
                                alt={item.nama_activity}
                                className="object-cover w-full h-48"
                            />
                            <div className="p-5">
                                <h3 className="text-xl font-bold">{item.nama_activity}</h3>
                                <p className="text-gray-600">{item.short_desc_activity}</p>
                                <Link
                                    to={`/team/${item.encrypted_id}`} // Menggunakan base64 encoded ID
                                    className="inline-block px-4 py-2 mt-3 text-white bg-blue-600 rounded transition hover:bg-blue-700"
                                >
                                    Detail
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="mt-10 text-center">
                    <Link
                        to={'/team'}
                        className="px-4 py-2 text-white bg-blue-600 rounded transition hover:bg-blue-700"
                    >
                        See Our Team
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ListKasi;
